/**
 * defa.views.ClaimOverviewForm
 * A view for forwarding a Unit to a Customer by email.
 * @version 1.2.0
 */
import Form from 'scripts/poppet/form';
import template from 'templates/claimOverviewForm.jst.html'

const ClaimOverviewForm = Form.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	template: template,
	
	templateContext: function () {
		return {
			customer        : this.getCustomerName(),
			context         : this.context,
			isPrepaid       : this.prepaid,
			packagePrice    : this.getPackagePrice(),
			subscriptionName: this.getPackageName(),
		};
	},
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
	/**
	 * The billing account to claim this subscription on.
	 * @return {string}  Name of the billing account.
	 */
	getCustomerName: function () {
		return ( this.options.customer )
			   ? this.options.customer.name()
			   : '';
	},
	
	/**
	 * The price of the subscription package to accept.
	 * @return {string}  The price of the package
	 */
	getPackagePrice: function () {
		return ( this.options.subscriptionPackage )
			   ? this.options.subscriptionPackage.get( 'transientFormatPackagePrice' )
			   : '';
	},
	
	/**
	 * The name of the subscription package to accept.
	 * @return {string}  The name of the package
	 */
	getPackageName: function () {
		return ( this.options.subscriptionPackage )
			   ? this.options.subscriptionPackage.get( 'transientName' )
			   : '';
	},
	
	/**
	 * Send the form.
	 * @void
	 */
	submit: function () {
		this.trigger( 'claim:acceptTotals' );
	},
	
} );

export default ClaimOverviewForm;